
export const EXHAUST_BOOSTER_FAN = 'exhaust-booster-fan';

export const EXHAUST_FAN_SPEED = 'exhaust-fan-speed';

export const FRESH_AIR = 'fresh-air';

export const INTAKE_BOOSTER_FAN = 'intake-booster-fan';

export const INTAKE_FAN_SPEED = 'intake-fan-speed';

export const TEMPERATURE = 'temperature';

export const DesiredSettingNameMap = {
  EXHAUST_BOOSTER_FAN: EXHAUST_BOOSTER_FAN,
  EXHAUST_FAN_SPEED: EXHAUST_FAN_SPEED,
  FRESH_AIR: FRESH_AIR,
  INTAKE_BOOSTER_FAN: INTAKE_BOOSTER_FAN,
  INTAKE_FAN_SPEED: INTAKE_FAN_SPEED,
  TEMPERATURE: TEMPERATURE,
};

export type DesiredSettingName = typeof DesiredSettingNameMap[keyof typeof DesiredSettingNameMap];

export const DesiredsettingNames = Object.values(DesiredSettingNameMap);